/** Synthetic student login: Firebase email/password uses firstname+admno@mpsvns.in (not a real inbox). */
const STUDENT_LOGIN_DOMAIN = 'mpsvns.in';

export function firstWordLocalPart(fullName) {
  const raw = String(fullName || '').trim().split(/\s+/)[0] || 'student';
  const ascii = raw
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');
  return ascii || 'student';
}

export function buildStudentLoginEmail(name, admno) {
  const a = String(admno ?? '').trim();
  if (!a) return '';
  return `${firstWordLocalPart(name)}${a}@${STUDENT_LOGIN_DOMAIN}`;
}

export function toStudentSignInEmail(input) {
  const raw = String(input || '').trim().toLowerCase();
  if (!raw) return '';
  if (raw.includes('@')) return raw.replace(/\s+/g, '');
  return `${raw.replace(/\s+/g, '')}@${STUDENT_LOGIN_DOMAIN}`;
}

export function isStudentLoginEmail(email) {
  return String(email || '').trim().toLowerCase().endsWith(`@${STUDENT_LOGIN_DOMAIN}`);
}

/** Match a registry row by synthetic login email. */
export function findRegistryStudentByEmail(students, email) {
  const normalized = String(email || '').trim().toLowerCase();
  if (!isStudentLoginEmail(normalized)) return null;
  return (
    (students || []).find((s) => {
      const loginEmail = buildStudentLoginEmail(s.studentName || s.name, s.admno || s.studentId);
      return loginEmail === normalized;
    }) || null
  );
}
